import { VFairWebinarShallow } from '~/services/types/vfair';
import WebinarMessageService from '~/services/WebinarMessageService';

interface WebinarMessageModuleState {
    webinars: VFairWebinarShallow[];
    service: WebinarMessageService | null;
}

export interface WebinarMessageModule {
    getWebinars: () => VFairWebinarShallow[];
    getUpcomingWebinars: (delta?: number) => VFairWebinarShallow[];

    addWebinars: (webinars: VFairWebinarShallow[]) => void;
    deleteWebinar: (webinarId: string) => void;

    setService: (service: WebinarMessageService) => void;
}

export default {
    state: {
        webinars: [],
        service: null as WebinarMessageService | null,
    } as WebinarMessageModuleState,
    getters: {
        getWebinars: (state: WebinarMessageModuleState) => () => state.webinars,
        getUpcomingWebinars: (state: WebinarMessageModuleState) => (delta = 5000 * 60) => {
            const upcoming: VFairWebinarShallow[] = state.webinars.filter(wb => {
                if (!wb.startTime) return false;

                const now = new Date().getTime();
                const start = new Date(wb.startTime).getTime();
                if (isNaN(start) || start < now) return false;

                return now > start - delta;
            });
            return upcoming;
        },

        getService: (state: WebinarMessageModuleState) => () => state.service,
    },
    mutations: {
        addWebinars(state: WebinarMessageModuleState, webinars: VFairWebinarShallow[]) {
            const newWebinars = webinars.filter(
                webinar => !state.webinars.some(wb => wb.id === webinar.id)
            );
            state.webinars = [...state.webinars, ...newWebinars];
        },
        deleteWebinar(state: WebinarMessageModuleState, webinarId: string) {
            state.webinars = state.webinars.filter(webinar => webinar.id !== webinarId);
        },

        setService(state: WebinarMessageModuleState, service: WebinarMessageService) {
            state.service = service;
        },
    },
};
